import { render } from "./FeaturesPageOne.vue?vue&type=template&id=a808aa9e"
import script from "./FeaturesPageOne.vue?vue&type=script&lang=js"
export * from "./FeaturesPageOne.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\digitaldistribution.io-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__